import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  tabPanelContent: {
    marginTop: theme.spacing(4),
  },
}));
